import '@hotwired/turbo-rails';
import type { Application } from '@hotwired/stimulus';
import { Dropdown, Tooltip } from 'bootstrap';
import SlimSelect from 'slim-select';

import './controllers';

// Import libraries
import NwEditor from './libs/nw_editor';
import NwTextCompletion from './libs/nw_text_completion';

// Declare Stimulus application and data fields on window variable
declare global {
  interface Window {
    Stimulus: Application;
    nattwenny: {
      creatureClassifications: string[];
      placeCategories: string[];
      autocomplete: { name: string; url: string }[];
    };
  }
}

// Initialize libraries
document.addEventListener('turbo:load', () => {
  NwEditor.initialize();
  NwTextCompletion.initialize();

  // Bootstrap dropdowns
  document.querySelectorAll<HTMLElement>('.dropdown-toggle').forEach((element) => {
    new Dropdown(element);
  });

  // Bootstrap tooltips
  document.querySelectorAll<HTMLElement>('.tooltipped').forEach((element) => {
    new Tooltip(element);
  });

  // SlimSelect multiple select field
  document.querySelectorAll<HTMLSelectElement>('.multiple-select').forEach((element) => {
    new SlimSelect({ select: element });
  });
});
